/**
 * Name: ProtectedRoutes
 * Author: @Gaurav
 * Date: 09-21-2020
 */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { _isAuthenticated } from '../utils';
import { setAuthToken } from '../axios';

const ProtectedRoutes = ({ routeType = [], component: Component, ...rest }) => {
  const { data } = _isAuthenticated();

  /**
   * check the routes authenticity
   * @param props
   */
  const _getRoute = (props) => {
    if (data) {
      const { access_token } = data;
      setAuthToken(access_token);

      return <Component {...props} />;
    } else {
      return <Redirect to="/" />;
    }
  };

  return <Route {...rest} render={(props) => _getRoute(props)} />;
};

export default ProtectedRoutes;
